<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">无线城市解决方案</div>
    </div>
    <section class="solutionConcept">
	<div class="solutionCaseBox" style="padding-bottom:0;">
    	<div class="solutionConceptBox">
        	<div class="solutionConceptBoxR"><img src="../../../static/images/solutionConceptPic1.jpg"></div>
            <div class="solutionConceptBoxL">
            	<div class="solutionConceptIn">
                	<div class="solutionConceptInTit">项目概念</div>
                    <div class="solutionConceptInConn">使用无线宽带技术实现城市热点区域的无线通信覆盖，向公众提供随时随地接入和高速度的无线网络，充分发挥IPv6即接即用的特性。</div>
                </div>
                <div class="solutionConceptArr"></div>
            </div>
        </div>
    </div>
</section>
<section class="solutionIncome">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit">客户收益</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<img src="../../../static/images/solutionDetailIcon01.png">
                <div class="solutionIncomeConn">提供差异化增值服务</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon02.png">
                <div class="solutionIncomeConn">提高营销广告<br />投放效果及收入</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon03.png">
                <div class="solutionIncomeConn">客户大数据分析<br />及人口流动定位</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon04.png">
                <div class="solutionIncomeConn">为城市规划和公共<br />交通提供精准数据依据</div>
            </li>
        </ul>
    </div>
</section>
<section class="solutionAdvantage">
	<div class="solutionAdvantageBox">
    	<div class="solutionAdvantageTit">项目优势</div>
    	<img src="../../../static/images/solutionAdvantageIcon01.png">
        <div class="solutionAdvantageConn" style="left:190px; top:210px;">
        	<div class="solutionAdvantageConnTit">覆盖广</div>
            <div class="solutionAdvantageConnMsg">提高城市无线网络覆盖范围</div>
        </div>
        <div class="solutionAdvantageConn" style="right:190px; top:210px;">
        	<div class="solutionAdvantageConnTit">便携接</div>
            <div class="solutionAdvantageConnMsg">随时随地接入高速无线网络</div>
        </div>
        <div class="solutionAdvantageConn" style="right:375px; bottom:60px;">
        	<div class="solutionAdvantageConnTit">低成本</div>
            <div class="solutionAdvantageConnMsg">降低单个终端的接入成本&nbsp;&nbsp;提高用户使用体验满意度</div>
        </div>
	</div>
</section>
<section class="solutionValue">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit">项目价值</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<img src="../../../static/images/solutionValuePic01.png">
                <div class="solutionIncomeConn">精准增强公共信息的推广</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionValuePic02.png">
                <div class="solutionIncomeConn">快速统计热点信息的访问量</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionValuePic03.png">
                <div class="solutionIncomeConn">辅助敏感信息的定位</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionValuePic04.png">
                <div class="solutionIncomeConn">绘制人口流动热点地图</div>
            </li>
        </ul>
    </div>
</section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage:'../../../static/images/solutionCaseBanner2.jpg?011901',
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solutionCase {
    .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner2.jpg?011902) no-repeat center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solutionCase4.vue